import { hospitalRegisterActions } from '../../../../actions/user/hospital/Account/registration';

const initialState = {
	user: null,
	loading: false,
	error: null,
	message: null,
	isModalOpen: false,
};

const hospitalRegisterReducer = (state = initialState, action) => {
	switch (action.type) {
		case hospitalRegisterActions.REGISTER_HOSPITAL.REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				message: null,
				isModalOpen: false,
			};
		case hospitalRegisterActions.REGISTER_HOSPITAL.SUCCESS:
			return {
				...state,
				user: action.payload,
				loading: false,
				error: null,
				message:
					action.payload.message ||
					'Registration successful. Check your email to verify.',
				isModalOpen: true,
			};
		case hospitalRegisterActions.REGISTER_HOSPITAL.FAILURE:
			return {
				...state,
				loading: false,
				error:
					action.payload?.message || 'An error occurred. Please try again.',
				isModalOpen: false,
			};
		case hospitalRegisterActions.REGISTER_HOSPITAL.RESET:
			return {
				...initialState,
			};
		default:
			return state;
	}
};

export default hospitalRegisterReducer;
